import request from '@/api/request'
export function fetchCadExport(data) {
    return request({
        url: '/model-analysis/cad/export/json',
        method: 'post',
        responseType: 'blob',
        data,
    })
}
export function fetchExportToDwg(data) {
    return request({
        url: `/model-analysis/expand/exportToDwg`,
        method: 'post',
        data,
        responseType: 'blob',
        timeout: 30000, // 30秒超时
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
export function fetchDetail(data) {
    return request({
        url: `/model-analysis/detection/query/${data.id}/${data.type}`,
    })
}

export function fetchDetailByCode(data) {
    return request({
        url: `/model-analysis/detection/queryByCode/${data.code}/${data.type}`,
    })
}

export function fetchDefectPipeList(data) {
    return request({
        url: '/model-analysis/detection/listDefectPipe',
        method: 'post',
        data,
    })
}

export function fetchDefectTestItemByCode(data) {
    return request({
        url: '/model-analysis/detection/listTestItemByCode',
        method: 'post',
        data,
    })
}